import {cn} from '@cohort/shared-frontend/utils/classNames';
import {DotsSixVertical, PencilSimple, Trash} from '@phosphor-icons/react';

type DraggableListItemProps = {
  children: React.ReactNode;
  className?: string;
  onEdit?: () => void;
  onRemove?: () => void;
  grow?: boolean;
  height?: number;
  visualElement?: React.ReactNode | null;
};

const DraggableListItem: React.FC<DraggableListItemProps> = ({
  children,
  className,
  onEdit,
  onRemove,
  grow,
  height = 52,
  visualElement,
}) => (
  <div className={cn('py-1', grow && 'grow')}>
    <div
      className={cn(
        'flex items-center justify-between gap-4 rounded-lg border bg-white shadow-sm',
        className
      )}
      style={{height}}
    >
      <div className="flex h-full items-center border-r px-4">
        <DotsSixVertical size={20} className="text-slate-400" />
      </div>
      {visualElement && (
        <div className="flex h-full items-center border-r pr-3.5">{visualElement}</div>
      )}
      <div className="flex-1">{children}</div>
      <div className="flex h-full items-center">
        {onEdit && (
          <button className="h-full border-l px-4" type="button" onClick={onEdit}>
            <PencilSimple size={20} className="text-gray-500" />
          </button>
        )}
        {onRemove && (
          <button className="h-full border-l px-4" type="button" onClick={onRemove}>
            <Trash size={20} className="text-red-400" />
          </button>
        )}
      </div>
    </div>
  </div>
);

export default DraggableListItem;
